const batteryData = {
    mainContent: {
        header: "Batteries",
        paragraph1: "Batteries to back up your home in case of a Texas grid outage. Most of the time these batteries are connected to solar which will recharge the batteries from the sun. We can back up whole homes and businesses or just specific electrical loads."
    }
}

export default batteryData;